<template>
    <div class="prevision-page">
      <!-- Cabecera: Filtros de tiempo -->
      <b-card no-body class="prevision-card-filtros mb-1">
        <b-card-body class="pb-75">
          <div class="d-flex align-items-center justify-content-between mb-75">
            <h4 class="mb-0"><i class="fa-solid fa-chart-line mr-50"></i> Prevision</h4>
            <div class="prevision-stats">
              <b-badge variant="light-success" class="prevision-stat-badge">
                <i class="fa-solid fa-coins mr-25"></i> Coste: {{ totalCoste }}
              </b-badge>
              <b-badge variant="light-primary" class="prevision-stat-badge">
                <i class="fa-solid fa-tag mr-25"></i> RRP: {{ totalRRP }}
              </b-badge>
              <b-badge variant="light-warning" class="prevision-stat-badge totalCheck">
                <i class="fa-solid fa-check-double mr-25"></i> Check: {{ totalCheck }}
              </b-badge>
            </div>
          </div>

          <div class="prevision-filtros">
            <div class="filtro-grupo">
              <div class="filtro-header">
                <span class="filtro-label">Años</span>
                <b-form-checkbox v-model="anyosTodosCheck" switch inline class="ml-75">
                  <small>Todos</small>
                </b-form-checkbox>
              </div>
              <div class="filtro-chips">
                <b-badge
                  v-for="(item, index) in anyos"
                  :key="'anyo-'+index"
                  :variant="item.active ? 'primary' : 'light-secondary'"
                  class="filtro-chip"
                  @click="item.active = !item.active"
                >
                  {{ item.nombre }}
                </b-badge>
              </div>
            </div>

            <div class="filtro-separador"></div>

            <div class="filtro-grupo">
              <div class="filtro-header">
                <span class="filtro-label">Meses</span>
                <b-form-checkbox v-model="mesesTodosCheck" switch inline class="ml-75 custom-control-info">
                  <small>Todos</small>
                </b-form-checkbox>
              </div>
              <div class="filtro-chips">
                <b-badge
                  v-for="(item, index) in meses"
                  :key="'mes-'+index"
                  :variant="item.active ? 'info' : 'light-secondary'"
                  class="filtro-chip"
                  @click="item.active = !item.active"
                >
                  {{ item.nombre }}
                </b-badge>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- Barra de controles -->
      <b-card no-body class="prevision-card-controles mb-1">
        <b-card-body class="py-75">
          <div class="d-flex align-items-end flex-wrap" style="gap: 0.75rem;">
            <b-form-group label="Mostrar" class="mb-0 prevision-select">
              <v-select v-model="mostrarSelect" label="nombre" :options="listadoMostrar" />
            </b-form-group>
            <b-form-group label="Localizacion" class="mb-0 prevision-select">
              <v-select v-model="localizacionSelect" label="nombre" :options="listadoLocalizacion" />
            </b-form-group>
            <b-form-group label="Tipo Sku" class="mb-0 prevision-select">
              <v-select v-model="tipoSelect" label="nombre" :options="listadoTipo" />
            </b-form-group>
            <b-form-group label="Pedido" class="mb-0 prevision-select">
              <v-select v-model="pedidoSelect" label="nombre" :options="listadoPedido" />
            </b-form-group>
            <b-form-group label="Agrupar" class="mb-0 prevision-agrupar">
              <b-button-group>
                <b-button :variant="agruparPor == 'sku' ? 'primary' : 'outline-primary'" @click="cambiarAgrupado('sku')">SKU</b-button>
                <b-button :variant="agruparPor == 'title' ? 'primary' : 'outline-primary'" @click="cambiarAgrupado('title')">Título</b-button>
              </b-button-group>
            </b-form-group>

            <b-button v-if="mostrarSelect == 'Pedido Actual'" variant="primary" size="sm" @click="generarPedido()">
              <i class="fa-solid fa-wand-magic-sparkles mr-50"></i> Generar pedido
            </b-button>

            <div class="ml-auto d-flex" style="gap: 0.5rem;">
              <b-button variant="outline-danger" size="sm" @click="borrarTodo()" v-b-tooltip.hover title="Borrar pedidos">
                <i class="fa-solid fa-eraser"></i>
              </b-button>
              <b-button variant="outline-success" size="sm" @click="descargarExcell()" v-b-tooltip.hover title="Descargar Excel">
                <i class="fa-solid fa-file-excel"></i>
              </b-button>
              <b-button variant="outline-primary" size="sm" @click="limpiarCheck()" v-b-tooltip.hover title="Limpiar check">
                <i class="fa-solid fa-eraser"></i>
                <i class="fa-regular fa-square-check ml-25"></i>
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- Buscador + Tabla -->
      <b-card no-body>
        <div v-if="cargando" class="prevision-cargando">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem;" />
          <span class="mt-1">Cargando datos...</span>
        </div>
        <template v-else>
        <b-card-body class="pb-0 pt-75">
          <b-form-input
            placeholder="Buscar SKU, titulo..."
            v-model="buscar"
            class="mb-75"
          />
        </b-card-body>

        <b-table
          :items="articulosBusqueda"
          :fields="columnasTable"
          :tbody-tr-class="filaClase"
          class="table table-borderless table-prevision mb-0"
          no-border-collapse
          sort-icon-left
          @sort-changed="sortChanged"
          striped
          hover
          ref="table"
        >
          <template #cell(check)="data">
            <span v-if="!data.item.esGrupo" @click="itemCheck()">
              <b-form-checkbox v-model="data.item.check"></b-form-checkbox>
            </span>
          </template>

          <template #cell(options)="data">
            <b-button v-if="!data.item.esGrupo" variant="flat-success" class="btn-icon rounded-circle" size="sm" @click="copySkuClipboard(data.item)">
              <feather-icon icon="CopyIcon" />
            </b-button>
          </template>

          <template #cell(sku)="data">
            <template v-if="data.item.esGrupo">
              <b-button variant="flat-primary" class="btn-icon rounded-circle mr-25" size="sm" @click="rowClick(data.item)" v-b-tooltip.hover title="Ver grafica">
                <i class="fa-solid fa-chart-line"></i>
              </b-button>
              <span class="sku-button grupo-titulo" @click="toggleGrupo(data.item)">
                <i :class="['fa-solid', expandidos[data.item.title] ? 'fa-chevron-down' : 'fa-chevron-right', 'mr-50']"></i>
                {{ data.item.title }}
                <b-badge variant="light-secondary" class="ml-50">{{ data.item.skus.length }}</b-badge>
              </span>
            </template>
            <div v-else-if="agruparPor == 'title'" class="d-flex align-items-center sku-hijo-controles">
              <span @click="itemCheck()">
                <b-form-checkbox v-model="data.item.check"></b-form-checkbox>
              </span>
              <b-button variant="flat-primary" class="btn-icon rounded-circle" size="sm" @click="rowClick(data.item)" v-b-tooltip.hover title="Ver grafica">
                <i class="fa-solid fa-chart-line"></i>
              </b-button>
              <span class="sku-texto sku-hijo">{{ data.item.sku }}</span>
              <b-button variant="flat-success" class="btn-icon rounded-circle" size="sm" @click="copySkuClipboard(data.item)">
                <feather-icon icon="CopyIcon" />
              </b-button>
              <div @click="cambiarLocalizacion(data.item)">
                <b-form-checkbox
                  class="custom-control-success margin-custom-control"
                  switch
                  v-model="data.item.localizacion"
                >
                  <span class="switch-icon-left">Ubr</span>
                  <span class="switch-icon-right">Elc</span>
                </b-form-checkbox>
              </div>
            </div>
            <template v-else>
              <b-button variant="flat-primary" class="btn-icon rounded-circle mr-25" size="sm" @click="rowClick(data.item)" v-b-tooltip.hover title="Ver grafica">
                <i class="fa-solid fa-chart-line"></i>
              </b-button>
              <span class="sku-texto">{{ data.item.sku }}</span>
            </template>
          </template>

          <template #cell(pedidoActual)="data">
            <span v-if="data.item.esGrupo">{{ data.item.pedidoActual }}</span>
            <b-form-input
              v-else
              v-model.lazy="data.item.pedidoActual"
              type="number"
              @wheel.prevent
              class="prevision-input-num"
              @focus="togglePicker(data)"
            />
          </template>

          <template #cell(pedidoAnual)="data">
            <span v-if="data.item.esGrupo">{{ data.item.pedidoAnual }}</span>
            <b-form-input
              v-else
              v-model.lazy="data.item.pedidoAnual"
              type="number"
              @wheel.prevent
              class="prevision-input-num"
              @focus="togglePicker(data)"
            />
          </template>

          <template #cell(localizacion)="data">
            <div v-if="!data.item.esGrupo" @click="cambiarLocalizacion(data.item)">
              <b-form-checkbox
                class="custom-control-success margin-custom-control"
                switch
                v-model="data.item.localizacion"
              >
                <span class="switch-icon-left">Ubr</span>
                <span class="switch-icon-right">Elc</span>
              </b-form-checkbox>
            </div>
          </template>
        </b-table>

        <div ref="sentinela" style="height: 1px;"></div>
        </template>
      </b-card>

      <!-- Modal analytics -->
      <b-modal id="modal-analityc" :title="itemSelect.sku" centered size="xl" hide-footer>
        <h4 class="card-title mb-1">Ventas de productos por mes</h4>
        <b-row>
          <b-col cols="9">
            <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
          </b-col>
          <b-col cols="3">
            <apexchart type="radar" height="350" :options="chartOptionsRadar" :series="series"></apexchart>
          </b-col>
        </b-row>
      </b-modal>
    </div>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable , BFormCheckbox, BFormInput, BFormGroup, BModal, BCardText, BCardBody, BCard, BRow, BCol, BButtonGroup, BSpinner} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { $themeColors } from '@themeConfig'
import { useTimeout } from '@vueuse/shared'
import vSelect from 'vue-select'
import { forEach } from 'postcss-rtl/lib/affected-props'
import { parse_xlscfb } from 'xlsx/xlsx.mjs'
import ExcelJS from 'exceljs'

  export default {
    components: {
        BCardCode,
        BFormCheckbox,
        BTable,
        BFormInput,
        BFormGroup,
        BCardText,
        BCardBody,
        BCard,
        BRow,
        BCol,
        BButtonGroup,
        BSpinner,
        vSelect,
    },
    data () {
      return {
        mesesTodosCheck: true,
        anyosTodosCheck: true,
        columnasAll: [
        {
          key: "check",
          label: "",
          sortable: false,
          thStyle: { width: "40px" },
        },
        {
          key: "options",
          label: "",
          sortable: false,
          thStyle: { width: "50px" },
        },
        {
          key: "sku",
          label: "SKU",
          sortable: true,
          thStyle: { minWidth: "220px" },
        },
        {
          key: "localizacion",
          label: "",
          sortable: false,
          thStyle: { width: "70px" },
        },
        {
          key: "pedidoActual",
          label: "Pedido Actual",
          sortable: true,
        },
        {
          key: "fabricando",
          label: "Fabricación",
          sortable: true,
        },
        {
          key: "pedidoAnual",
          label: "Pedido Anual",
          sortable: true,
        },
        {
          key: "stock",
          label: "Stock",
          sortable: true,
        },
        {
          key: "stockIdeal",
          label: "Stock Ideal",
          sortable: true,
        },
        {
          key: "prevision",
          label: "Previsión",
          sortable: true,
        }],
        columnasTable: [],
        articulos: [],
        articulosBusqueda: [],
        articulosBusquedaAll: [],
        meses: [
          {nombre: "Enero", value: 1, active: true},
          {nombre: "Febrero", value: 2, active: true},
          {nombre: "Marzo", value: 3, active: true},
          {nombre: "Abril", value: 4, active: true},
          {nombre: "Mayo", value: 5, active: true},
          {nombre: "Junio", value: 6, active: true},
          {nombre: "Julio", value: 7, active: true},
          {nombre: "Agosto", value: 8, active: true},
          {nombre: "Septiembre", value: 9, active: true},
          {nombre: "Octubre", value: 10, active: true},
          {nombre: "Noviembre", value: 11, active: true},
          {nombre: "Diciembre", value: 12, active: true}
          ],
        anyos: Array.from({ length: new Date().getFullYear() - 2019 + 1 }, function(_, i) {
          var y = new Date().getFullYear() - i
          return { nombre: String(y), value: y, active: true }
        }),
        buscar: "",
        agruparPor: "sku",
        expandidos: {},
        countItemView: 30,
        nextScrollItemView: 20,
        defaultItemView: 30,
        itemSelect: {pedido: undefined},
        watching: true,
        lastSort: null,
        guardandoLocal: false,
        series: [{
              name: "Desktops",
              data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
          }],
        chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            title: {
              text: '',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            }
          },
          chartOptionsRadar: {
             chart: {
              height: 350,
              type: 'radar',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            title: {
              text: '',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            }
          },
          listadoMostrar: ["Todos", "Pedido Actual", "Pedido Anual"],
          listadoLocalizacion: ["Todos", "Elche", "Ubrique"],
          localizacionSelect: "Todos",
          mostrarSelect: "Todos",
          listadoTipo: ["Todos", "A", "B"],
          tipoSelect: 'Todos',
          listadoPedido: ["Todos", "Pedidos", "Sin Pedir"],
          pedidoSelect: 'Todos',
          listadoProductos: [],
          totalRRP: '0,00€',
          totalCoste: '0,00€',
          totalCheck: '£0',
          allArticulosShopify: null,
          cargando: true
      }
    },
    methods:{
      loadItems(){
        //console.log("start");
        this.cargarColumnas();

        axios.post("/uso", {seccion:"prevision"});

        const fetchArticulosShopify = axios.get("/articulos/shopify").then(response => response.data);
        const fetchVentasMensual = axios.get("/ventas/mensual").then(response => response.data);
        //const fetchArticulosVariants = axios.get("/articulos/variants").then(response => response.data);
        const fetchFinanzasArticulos = axios.get("/finanzas/articulos").then(response => response.data);

        const fetchArticulosPedido = axios.get("/articulos/sku/pedido").then(response => response.data);
        const fetchFabricando = axios.get("/taller/pedido/vero/fabricando", { params: { tipo: "B2C" } }).then(response => response.data);



        Promise.all([fetchArticulosShopify, fetchVentasMensual, fetchFinanzasArticulos, fetchArticulosPedido, fetchFabricando])
          .then(([articulosShopify, ventasMensual, finanzasArticulos, articulosPedido, fabricando]) => {
            // Unidades pendientes en taller (pedidos Vero no terminados): en fabricación + pre-producción
            const fabricandoMap = new Map(fabricando.map(f => [f.sku, Number(f.totalFabricando) + Number(f.totalPreProduccion)]));

            // Procesar datos de articulosShopify
            const variantsArray = articulosShopify.flatMap(item =>               
              item.variants.map(variant => ({
                sku: variant.sku,
                stock: variant.inventory_quantity,
                price: variant.price
              }))
            );

            this.allArticulosShopify = articulosShopify;

            //Preio: Libras, Rumano

            this.listadoProductos = variantsArray;

            this.articulos = Array.from(
              articulosShopify.flatMap(item =>
                item.variants
                  .filter(variant => variant.sku)
                  .map(variant => {
                    const image = item.images.find(img => img.id === variant.image_id) || {};
                    const pedido = articulosPedido.find(art => art.sku === variant.sku) || {};

                    let localizacion = pedido.localizacion == 1;

                    return {
                      sku: variant.sku,
                      title: item.title || '',
                      precio: parseFloat(variant.price),
                      image: image.src || '',
                      shopify_product_id: variant.id,
                      stock: variant.inventory_quantity,
                      stockIdeal: '',
                      cantidades: [],
                      confeccion: 0,
                      confeccionUbrique: 0,
                      localizacion: localizacion || false,
                      pedidoActual: pedido.actual || '',
                      pedidoAnual: pedido.anual || '',
                      fabricando: fabricandoMap.get(variant.sku) || '',
                      check: false
                    };
                  })
              ).reduce((acc, item) => {
                acc.set(item.sku, item);
                return acc;
              }, new Map()).values()
            );



            // Procesar datos de finanzasArticulos
            this.articulos.forEach(articulo => {
              for (let precio of finanzasArticulos) {
                if (articulo.sku.includes(precio.sku)) {
                  articulo.confeccion = precio.confeccion;
                  articulo.confeccionUbrique = precio.ubrique;
                  break;
                }
              }
            });



            // Procesar ventasMensual
            const articulosMap = new Map();

            //Optimizado
            this.articulos.forEach(articulo => {
              const cantidadesMap = new Map();
              articulo.cantidades.forEach(cantidad => {
                cantidadesMap.set(`${cantidad.anyo}_${cantidad.mes}`, cantidad);
              });
              
              articulo.cantidades = cantidadesMap;
              articulosMap.set(articulo.sku, articulo);
            });

            ventasMensual.forEach(dato => {
              const articulo = articulosMap.get(dato.sku);
              
              if (articulo) {
                const claveMesAnyo = `${dato.anyo}_${dato.mes}`;
                const cantidadExistente = articulo.cantidades.get(claveMesAnyo);
                
                if (cantidadExistente) {
                  cantidadExistente.total += dato.cantidad;
                } else {
                  articulo.cantidades.set(claveMesAnyo, {
                    anyo: dato.anyo,
                    mes: dato.mes,
                    total: dato.cantidad
                  });
                }
              }
            });

            this.articulos.forEach(articulo => {
                articulo.cantidades = Array.from(articulo.cantidades.values());
            });
            //  Lento
            // ventasMensual.forEach(element => {
            //   this.addCantidadAnyos(element);
            // });



            // Calcular previsiones y cantidades por año
            this.articulos.forEach(arti => {
              this.calcularPrevisiones(arti);
              this.anyos.forEach(element => {
                this.getCantidadAnyo(arti, element.value);
              });
            });


            this.articulos.sort((a, b) => a.sku.localeCompare(b.sku));

            // Actualizar listas de articulos para la búsqueda
            this.articulosBusquedaAll = this.articulos;
            this.articulosBusqueda = this.articulos.slice(0, this.countItemView);

            //console.log(this.articulosBusqueda);

            this.calcularRRPyCoste();

            this.cargando = false;
          })
          .catch(error => {
            console.error("Error al realizar las llamadas a las API:", error);
            this.cargando = false;
          });
      },
      cargarColumnas()
      {

        this.columnasTable = [];

        this.columnasAll.forEach(column => {
          if(this.agruparPor == 'title' && ['check', 'options', 'localizacion'].includes(column.key)) return;
          this.columnasTable.push(column);

        });

        this.anyos.forEach(item => {
          if(item.active)
          {
            this.columnasTable.push(
              {
                key: item.nombre,
                label: item.nombre,
                sortable: true,
              }
            );

          }
        });
      },
      actualizarStickyTop()
      {
        // Limitado a un calculo por frame para no penalizar el scroll
        if(this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => {
          this.stickyFrame = null;
          // Mide donde termina el menu fijo superior para anclar la cabecera de la tabla justo debajo
          let menu = document.querySelector('.horizontal-menu-wrapper .navbar-horizontal')
            || document.querySelector('.header-navbar');
          let top = Math.max(menu ? menu.getBoundingClientRect().bottom : 0, 0) + 'px';
          if(top != this.stickyTopActual)
          {
            this.stickyTopActual = top;
            this.$el.style.setProperty('--sticky-top', top);
          }
        });
      },
      addCantidadAnyos(dato)
      {

        let articulo = this.articulos.filter(function (el) {
          return el.sku == dato.sku;
        });

        if(articulo.length > 0)
        {

          let cantidadAnyo = articulo[0].cantidades.filter(function (el) {
            return el.anyo == dato.anyo && el.mes == dato.mes;
          });

          if(cantidadAnyo.length > 0)
          {
            cantidadAnyo[0].total += dato.cantidad;
          }
          else
          {
            articulo[0].cantidades.push({anyo: dato.anyo, mes: dato.mes, total: dato.cantidad});
          }
          
        }

      },
      getCantidadAnyo(item, anyo)
      {

        let total = 0;

        let tieneValor = false;

        this.meses.forEach(mes => {

          if(mes.active)
          {

            let cantidad = item.cantidades.filter(function (el) {
              return el.anyo == anyo && el.mes == mes.value;
            });

            if(cantidad.length > 0)
            {
              total += cantidad[0].total
              tieneValor = true;
            }

          }
          
        });

        if(total == 0 && !tieneValor)
          total = "";

        item[anyo] = total;

        /*if(total == "")
          return 0;*/

        return total;

      },
      calcularRRPyCoste(){

          const findPriceBySku = (sku) => {
              const variant = this.listadoProductos.find(v => v.sku === sku);
              return variant ? Number(variant.price) : null;
          };

          let totalPrice = 0;
          let coste = 0;

          //console.log(this.articulosBusquedaAll);

          this.articulos.forEach(articulo => {

            let priceSku = findPriceBySku(articulo.sku);

            if(priceSku != null && articulo.pedidoActual != "" && articulo.pedidoActual != undefined)
            {
              //console.log(articulo.sku + ': ' + articulo.pedidoActual );
              totalPrice += priceSku * articulo.pedidoActual;

              if(articulo.localizacion)
              {
                coste += articulo.confeccionUbrique * articulo.pedidoActual;
              }
              else
              {
                coste += articulo.confeccion * articulo.pedidoActual;
              }
            }            
           
          });

          this.totalRRP = totalPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',') + '€';;
          this.totalCoste = coste.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',') + '€';;

      },
      calcularPorcentajeVenta()
      {
        let elche = 0;
        let ubrique = 0;

        //console.log(this.getCantidadAnyo(this.articulos[1],"2023"));

        this.articulos.forEach(articulo => {

          if(articulo.localizacion == false)
          {
            elche += parseInt(this.getCantidadAnyo(articulo,"2022"));
            elche += parseInt(this.getCantidadAnyo(articulo,"2023"));
            
          }
          else{
            ubrique += parseInt(this.getCantidadAnyo(articulo,"2022"));
            ubrique += parseInt(this.getCantidadAnyo(articulo,"2023"));
            
          }
        });

        /*console.log("Elche: " + elche);
        console.log("Ubrique: " + ubrique);*/
      },
      calcularPrevisiones(item)
      {

         let total = 0;

        let auxAnyos = JSON.parse(JSON.stringify(this.anyos));

        if(auxAnyos[0].value == new Date().getFullYear())
        {
            let valido = true;

            let mesActual = new Date().getMonth()+1;
            this.meses.forEach(mes => {
                if(mes.active && mes.value >= mesActual)
                    valido = false;
            });

            if(!valido)
                auxAnyos.shift();
        }

        auxAnyos = auxAnyos.filter(function( obj ) {
            return obj.active == true;
        });

        auxAnyos.forEach(anyo => {
            if(anyo.active)
            {
                anyo.total = 0;

                this.meses.forEach(mes => {
                    if(mes.active)
                    {
                        let cantidad = item.cantidades.filter(function (el) {
                            return el.anyo == anyo.value && el.mes == mes.value;
                        });

                        if(cantidad.length > 0)
                        {
                            anyo.total += cantidad[0].total
                        }
                    }
                });
            }
        });

        let startCount = false;

        let cantidadAnyos = 0;
        let porcentajeAnyos = 0;

        let ultimoValorValido = 0;

        for (let y = auxAnyos.length-1; y >= 0; y--) {
            if(auxAnyos[y].active && (auxAnyos[y].total > 0 || startCount) )
            {
                cantidadAnyos++;
                startCount = true;
                if(y > 0)
                {
                    let aux = auxAnyos[y-1].total-auxAnyos[y].total;
                    porcentajeAnyos += aux;   
                }

                ultimoValorValido = auxAnyos[y].total;
            }
        }


        total = porcentajeAnyos / cantidadAnyos;

        if(total > 0)
        {
            total = ultimoValorValido + total;
        }
        else
        {
            total = ultimoValorValido - total;
        }

        if(isNaN(total))
            total = "";
        else
            total = Math.round(total);

        item.prevision = total;
        item.stockIdeal = total - item.stock;

        if(item.stockIdeal <= 0)
            item.stockIdeal = "";
      },
      getFuturoPorcentaje(item)
      {
        let total = 0;

        let auxAnyos = JSON.parse(JSON.stringify(this.anyos));

        if(auxAnyos[0].value == new Date().getFullYear())
            auxAnyos.shift();
        
        auxAnyos.forEach(anyo => {
            if(anyo.active)
            {
                anyo.total = 0;

                this.meses.forEach(mes => {
                    if(mes.active)
                    {
                        let cantidad = item.cantidades.filter(function (el) {
                            return el.anyo == anyo.value && el.mes == mes.value;
                        });

                        if(cantidad.length > 0)
                        {
                            anyo.total += cantidad[0].total
                        }
                    }
                });
            }
        });

        let startCount = false;

        let cantidadAnyos = 0;
        let porcentajeAnyos = 0;

        let ultimoValorValido = 0;

        for (let y = auxAnyos.length-1; y >= 0; y--) {
            if(auxAnyos[y].active && (auxAnyos[y].total > 0 || startCount) )
            {
                cantidadAnyos++;
                startCount = true;
                if(y > 0)
                {
                    let aux = ((auxAnyos[y-1].total-auxAnyos[y].total)/auxAnyos[y].total)*100;
                    porcentajeAnyos += aux;   
                }

                ultimoValorValido = auxAnyos[y].total;
            }
        }


        total = porcentajeAnyos / cantidadAnyos;

        
        /*if(total == 0)
            return ultimoValorValido*/

        if(total > 0)
        {
            total = ultimoValorValido + (total/100*ultimoValorValido)
        }
        else
        {
            total = ultimoValorValido - (total/100*ultimoValorValido)
        }

        if(isNaN(total))
            total = "";
        else
            total = Math.round(total);

        return total;

      },
      getStockProduccion(item){
        let aux = item.prevision - item.stock;
        if(aux <= 0)
            aux = "";
        return aux;
      },
      loadMore() {
        this.countItemView += this.nextScrollItemView;
        this.buscarFuncion();
      },
      iniciarObserver()
      {
        // Carga mas filas cuando el final de la tabla se acerca a la pantalla (independiente del contenedor con scroll)
        if(this.observer) this.observer.disconnect();
        if(!this.$refs.sentinela) return;
        this.observer = new IntersectionObserver(entries => {
          if(entries[0].isIntersecting) this.comprobarSentinela();
        }, { rootMargin: '0px 0px 600px 0px' });
        this.observer.observe(this.$refs.sentinela);
      },
      comprobarSentinela()
      {
        // El observer solo avisa al entrar; si tras cargar sigue visible hay que seguir cargando
        this.$nextTick(() => {
          let sentinela = this.$refs.sentinela;
          if(!sentinela || this.scrollCompleto) return;
          if(sentinela.getBoundingClientRect().top < window.innerHeight + 600)
            this.loadMore();
        });
      },
      togglePicker(data)
      {
        this.itemSelect = data.item;
      },
      copySkuClipboard(data){
        navigator.clipboard.writeText(data.sku);
      },
      cambiarLocalizacion(data)
      {

        if(!this.guardandoLocal)
        {
          this.guardandoLocal = true;

          let boolConver = 0;

          if(!data.localizacion)
            boolConver = 1;

          axios
            .post("/articulos/localizacion", {sku: data.sku, localizacion: boolConver})
            .then(response => {
                return response.data;
            })
            .then(res => {

              let serie = this.articulos.filter(function (el) {
                return el.sku == data.sku;
              });

              if(serie.length > 0)
              {
                serie[0].localizacion = data.localizacion;
              }

              this.guardandoLocal = false;

              if(this.localizacionSelect != "Todos")
              {
                this.countItemView = this.defaultItemView;
                this.recalcularDatos();
              }
            
            });

        }

      },
      rowClick(data)
      {
        if(data.esGrupo)
        {
          // Grafica agregada: suma las cantidades de todos los skus del grupo
          let mapa = {};
          let cantidades = [];

          data.skus.forEach(hijo => {
            (hijo.cantidades || []).forEach(c => {
              let clave = c.anyo + '-' + c.mes;
              if(mapa[clave])
                mapa[clave].total += parseFloat(c.total) || 0;
              else
              {
                mapa[clave] = { anyo: c.anyo, mes: c.mes, total: parseFloat(c.total) || 0 };
                cantidades.push(mapa[clave]);
              }
            });
          });

          this.itemSelect = { sku: data.title, cantidades: cantidades };
        }
        else
          this.itemSelect = data;

        this.calcularGrafica();
        this.$bvModal.show('modal-analityc');
      },
      calcularGrafica()
      {
         let auxSeries = [];

         const anyosActivos = this.anyos.filter(a => a.active).map(a => a.value);

         this.itemSelect.cantidades.forEach(item => {

          if(!anyosActivos.includes(parseInt(item.anyo)))
            return;

          let serie = auxSeries.filter(function (el) {
            return el.name == String(item.anyo);
          });

          if(serie.length > 0)
          {
            serie[0].data[item.mes-1] = item.total;
          }
          else
          {

            let newYear = {
              name: String(item.anyo),
              data: [0,0,0,0,0,0,0,0,0,0,0,0]
            };

            //data: [null,null,null,null,null,null,null,null,null,null,null,null,null]
            //data: [0,0,0,0,0,0,0,0,0,0,0,0,0]

            newYear.data[item.mes-1] = item.total;

            auxSeries.push(newYear);
          }

         });

         /*{
              name: "2019",
              data: [10, 41, 35, 51, 49, 62, 69, 91, 148,100,100,100]
          }*/
          
        let auxChart = {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            title: {
              text: '',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            }
          };

          this.series = [];
          //this.chartOptions = {};
          setTimeout(()=>{
            this.series = auxSeries;
            //this.chartOptions = auxChart;
          }, 100);
      

      },
      agruparPorTitulo(items)
      {
        const camposSuma = ['stock', 'stockIdeal', 'prevision', 'pedidoActual', 'fabricando', 'pedidoAnual']
          .concat(this.anyos.map(a => a.nombre));

        let mapa = new Map();

        items.forEach(articulo => {
          let clave = articulo.title || articulo.sku;
          if(!mapa.has(clave))
          {
            let grupo = { esGrupo: true, title: clave, sku: clave, skus: [] };
            camposSuma.forEach(c => grupo[c] = 0);
            mapa.set(clave, grupo);
          }
          let grupo = mapa.get(clave);
          articulo.esHijo = true;
          grupo.skus.push(articulo);
          camposSuma.forEach(c => {
            let v = parseFloat(articulo[c]);
            if(!isNaN(v)) grupo[c] += v;
          });
        });

        let grupos = Array.from(mapa.values());

        grupos.forEach(grupo => {
          camposSuma.forEach(c => { if(grupo[c] == 0) grupo[c] = ""; });
        });

        if(this.lastSort != null)
        {
          let campo = this.lastSort.sortBy == "sku" ? "title" : this.lastSort.sortBy;
          if(campo == "title")
            grupos.sort((a, b) => this.lastSort.sortDesc ? b.title.localeCompare(a.title) : a.title.localeCompare(b.title));
          else
            grupos.sort((a, b) => this.lastSort.sortDesc ? (b[campo] || 0) - (a[campo] || 0) : (a[campo] || 0) - (b[campo] || 0));
        }
        else
          grupos.sort((a, b) => a.title.localeCompare(b.title));

        return grupos;
      },
      cambiarAgrupado(modo)
      {
        this.agruparPor = modo;
        this.expandidos = {};
        this.countItemView = this.defaultItemView;
        this.cargarColumnas();
        this.buscarFuncion();
      },
      toggleGrupo(grupo)
      {
        this.$set(this.expandidos, grupo.title, !this.expandidos[grupo.title]);
        this.buscarFuncion();
      },
      filaClase(item)
      {
        if(!item) return '';
        if(item.esGrupo) return 'fila-grupo';
        if(item.esHijo && this.agruparPor == 'title') return 'fila-hijo';
        return '';
      },
      sortChanged(e) {

        this.lastSort = e;

        /*let auxSorting = JSON.parse(JSON.stringify(this.articulos));

        if(e.sortDesc)
          auxSorting.sort((a,b) => b[e.sortBy] - a[e.sortBy]);
        else
          auxSorting.sort((a,b) => a[e.sortBy] - b[e.sortBy]);


        auxSorting = auxSorting.slice(0,this.countItemView);

        this.buscarFuncion(auxSorting);*/
        this.buscarFuncion();

      },
      buscarFuncionOpt(items = this.articulos) {
          let auxSorting = [...items];

          if (this.lastSort != null && this.lastSort.sortBy !== undefined && this.lastSort.sortDesc !== undefined) {
              const compareFn = (a, b) => {
                  const valA = typeof a[this.lastSort.sortBy] === 'string' ? a[this.lastSort.sortBy].toLowerCase() : a[this.lastSort.sortBy];
                  const valB = typeof b[this.lastSort.sortBy] === 'string' ? b[this.lastSort.sortBy].toLowerCase() : b[this.lastSort.sortBy];
                  return (this.lastSort.sortDesc ? valB - valA : valA - valB);
              };
              
              auxSorting.sort(compareFn);

              if (this.lastSort.sortBy === 'sku') {
                  auxSorting.sort((a, b) => (this.lastSort.sortDesc ? b.sku.localeCompare(a.sku) : a.sku.localeCompare(b.sku)));
              }
          }

          const filterFunctions = {
              'Pedido Actual': (el) => el.pedidoActual !== undefined && el.pedidoActual > 0,
              'Pedido Anual': (el) => el.pedidoAnual !== undefined && el.pedidoAnual > 0,
              'Elche': (el) => !el.localizacion,
              'Ubrique': (el) => el.localizacion,
              'A': (el) => {
                  const sku = el.sku.toLowerCase();
                  return sku.includes('bag') || sku.includes('briefcase') || sku.includes('backpack') || sku.includes('nomad');
              },
              'B': (el) => {
                  const sku = el.sku.toLowerCase();
                  return !(sku.includes('bag') || sku.includes('briefcase') || sku.includes('backpack') || sku.includes('nomad'));
              }
          };

          if (this.mostrarSelect in filterFunctions) {
              auxSorting = auxSorting.filter(filterFunctions[this.mostrarSelect]);
          }

          if (this.tipoSelect in filterFunctions) {
              auxSorting = auxSorting.filter(filterFunctions[this.tipoSelect]);
          }

          if (this.pedidoSelect === 'Pedidos') {
              auxSorting = auxSorting.filter((el) => (el.pedidoActual && el.pedidoActual.length > 0) || (el.pedidoAnual && el.pedidoAnual.length > 0));
          } else if (this.pedidoSelect === 'Sin Pedir') {
              auxSorting = auxSorting.filter((el) => !(el.pedidoActual && el.pedidoActual.length > 0) && !(el.pedidoAnual && el.pedidoAnual.length > 0));
          }

          items = auxSorting;

          this.articulosBusquedaAll = items;

          if (this.buscar === "") {
            this.articulosBusqueda = items.slice(0, this.countItemView);
          } else {
            const busquedaLowerCase = this.buscar ? this.buscar.toLowerCase() : '';
            this.articulosBusqueda = items
                .filter(articulo => articulo.sku && articulo.sku.toLowerCase().includes(busquedaLowerCase))
                .slice(0, this.countItemView);
          }

          this.articulosBusqueda.forEach(element => {

            if(element.pedidoActual == "undefined")
              element.pedidoActual = "";

            if(element.pedidoAnual == "undefined")
              element.pedidoAnual = "";

          });


          

      },
      buscarFuncion(items = this.articulos ){

        // Copia superficial: el deep clone con JSON de todos los articulos bloqueaba el scroll
        let auxSorting = [...items];

        if(this.lastSort != null)
        {
          if(this.lastSort.sortDesc)
            auxSorting.sort((a,b) => b[this.lastSort.sortBy] - a[this.lastSort.sortBy]);
          else
            auxSorting.sort((a,b) => a[this.lastSort.sortBy] - b[this.lastSort.sortBy]);

          if(this.lastSort.sortBy == "sku")
          {
            if(this.lastSort.sortDesc)
              auxSorting.sort((a, b) => b.sku.localeCompare(a.sku))
            else
              auxSorting.sort((a, b) => a.sku.localeCompare(b.sku))
          }

        }

        if(this.mostrarSelect == "Pedido Actual")
        {
          auxSorting = auxSorting.filter(function (el) {
            return el.pedidoActual != undefined && el.pedidoActual > 0;
          });
        }
        else if(this.mostrarSelect == "Pedido Anual")
        {
          auxSorting = auxSorting.filter(function (el) {
            return el.pedidoAnual != undefined && el.pedidoAnual > 0;
          });
        }

        if(this.localizacionSelect == "Elche")
        {
          auxSorting = auxSorting.filter(function (el) {
            return el.localizacion == false ;
          });
        }
        else if(this.localizacionSelect == "Ubrique")
        {
          auxSorting = auxSorting.filter(function (el) {
            return el.localizacion == true ;
          });
        }

        if(this.tipoSelect == "A")
        {
          auxSorting = auxSorting.filter(function (el) {
              let sku = el.sku.toLowerCase();
              return (sku.includes('bag') || sku.includes('briefcase') || sku.includes('backpack') || sku.includes('nomad') || sku.includes('rucksack') );
          });
        }
        else if(this.tipoSelect == "B")
        {
          auxSorting = auxSorting.filter(function (el) {
              let sku = el.sku.toLowerCase();
              return !(sku.includes('bag') || sku.includes('briefcase') || sku.includes('backpack') || sku.includes('nomad') || sku.includes('rucksack'));
          });
        }

        if (this.pedidoSelect == "Pedidos") {
            auxSorting = auxSorting.filter(function (el) {
                return ((el.pedidoActual && el.pedidoActual.length > 0) || (el.pedidoAnual && el.pedidoAnual.length > 0));
            });
        }
        else if (this.pedidoSelect == "Sin Pedir") {
            auxSorting = auxSorting.filter(function (el) {
                return !(el.pedidoActual && el.pedidoActual.length > 0) && !(el.pedidoAnual && el.pedidoAnual.length > 0);
            });
        }

        items = auxSorting;
        
        this.articulosBusqueda = [];
        this.articulosBusquedaAll = [];

        if(this.buscar != "")
        {
          let busq = this.buscar.toLowerCase();
          items = items.filter(articulo =>
            (articulo.sku && articulo.sku.toLowerCase().includes(busq)) ||
            (articulo.title && articulo.title.toLowerCase().includes(busq))
          );
        }

        if(this.agruparPor == "title")
        {
          let grupos = this.agruparPorTitulo(items);
          this.articulosBusquedaAll = items;
          let visibles = [];
          grupos.slice(0, this.countItemView).forEach(grupo => {
            visibles.push(grupo);
            if(this.expandidos[grupo.title])
              grupo.skus.forEach(hijo => visibles.push(hijo));
          });
          this.articulosBusqueda = visibles;
        }
        else
        {
          this.articulosBusquedaAll = items;
          this.articulosBusqueda = items.slice(0,this.countItemView);
        }

        this.articulosBusqueda.forEach(element => {

          if(element.pedidoActual == "undefined")
            element.pedidoActual = "";

          if(element.pedidoAnual == "undefined")
            element.pedidoAnual = "";

        });

        this.comprobarSentinela();
      },
      buscarFiltro(items = this.articulos ){

        let auxSorting = JSON.parse(JSON.stringify(items));

        if(this.lastSort != null)
        {
          if(this.lastSort.sortDesc)
            auxSorting.sort((a,b) => b[this.lastSort.sortBy] - a[this.lastSort.sortBy]);
          else
            auxSorting.sort((a,b) => a[this.lastSort.sortBy] - b[this.lastSort.sortBy]);

          if(this.lastSort.sortBy == "sku")
          {
            if(this.lastSort.sortDesc)
              auxSorting.sort((a, b) => b.sku.localeCompare(a.sku))
            else
              auxSorting.sort((a, b) => a.sku.localeCompare(b.sku))
          }

        }

        if(this.mostrarSelect == "Pedido Actual")
        {
          auxSorting = auxSorting.filter(function (el) {
            return el.pedidoActual != undefined && el.pedidoActual > 0;
          });
        }
        else if(this.mostrarSelect == "Pedido Anual")
        {
          auxSorting = auxSorting.filter(function (el) {
            return el.pedidoAnual != undefined && el.pedidoAnual > 0;
          });
        }

        if(this.localizacionSelect == "Elche")
        {
          auxSorting = auxSorting.filter(function (el) {
            return el.localizacion == false ;
          });
        }
        else if(this.localizacionSelect == "Ubrique")
        {
          auxSorting = auxSorting.filter(function (el) {
            return el.localizacion == true ;
          });
        }

        items = auxSorting;

        this.articulosBusqueda = [];
        this.articulosBusquedaAll = [];

        if(this.buscar == "")
        {
          this.articulosBusquedaAll = items;
          this.articulosBusqueda = items.slice(0,this.countItemView);
        }
        else
        {
          let articulosEncontrado = [];
          items.forEach(articulo => {
            if(articulo.sku.toLowerCase().includes(this.buscar.toLowerCase()))
              articulosEncontrado.push(articulo);
          });

          this.articulosBusquedaAll = articulosEncontrado;
          this.articulosBusqueda = articulosEncontrado.slice(0,this.countItemView);
        }
      },
      recalcularDatos()
      {
        this.watching = false;
        this.cargarColumnas();
          /*this.articulos.forEach(arti => {
              this.calcularPrevisiones(arti);
          });*/
        this.articulos.forEach(arti => {
            this.calcularPrevisiones(arti);
            this.anyos.forEach(element => {
              this.getCantidadAnyo(arti,element.nombre)
            });
        });

        this.watching = true;

        this.buscarFuncion();
      },    
      borrarTodo() {
        this.$swal({
          title: '¿Estas seguro que quieres borrar todos los pedidos?',
          text: "Este accion es definitiva.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, borrar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {

            axios
              .post("/articulos/sku/pedido/delete", {})
              .then(response => {
                  return response.data;
              })
              .then(res => {

                 this.articulos.forEach(element => {
                      element.pedidoAnual = ""
                      element.pedidoActual = "";
                  });

                  this.articulosBusqueda.forEach(element => {
                      element.pedidoAnual = "";
                      element.pedidoActual = "";
                  });

                this.$swal({
                  icon: 'success',
                  title: 'Borrado',
                  text: 'Los pedidos se han borrado con exito.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              });
          }
        })
      },
      descargarExcell(){
        // Los articulos marcados con el check; si no hay ninguno, todos los del listado actual
        let seleccionados = this.articulos.filter(x => x.check);

        if(seleccionados.length == 0)
          seleccionados = this.articulosBusquedaAll;

        var csv = "Sku;Stock;Stock Ideal;Prevision;Precio;PEDIR;TOTAL\n";

        seleccionados.forEach(data => {
          let precio = 0;
          if(data.localizacion)
            precio = data.confeccionUbrique; //ubrique
          else
          precio = data.confeccion;

          csv += data.sku+";"+data.stock+";"+data.stockIdeal+";"+data.prevision+";"+precio+";;\n";
        });

        navigator.clipboard.writeText(csv);

        this.$swal({
                  icon: 'success',
                  title: 'Los productos se han copiado correctamente: ' + seleccionados.length,
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              })
      },
      generarPedido()
      {

        const fechaActual = new Date();
        const dia = fechaActual.getDate().toString().padStart(2, '0');
        const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
        const anio = fechaActual.getFullYear().toString();

        let itemsToPedido = this.articulos
        .filter(el => el.pedidoActual !== undefined && el.pedidoActual > 0)
        .map(objeto => ({
          sku: objeto.sku,
          cantidad: objeto.pedidoActual,
          fecha: "",
          completados: ""
        }));

        let dataSend = {fecha: `${dia}-${mes}-${anio}`, listaSku: itemsToPedido};

        axios
          .post("/taller/pedidos/new", dataSend)
          .then(response => {
              return response.data;
          })
          .then(res => {
            //console.log(res);

            this.$swal({
                  icon: 'success',
                  title: 'Creado',
                  text: 'El pedido para el taller se ha generado con exito.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })

          });

        /*console.log(itemsToPedido);
        
        console.log("Generar pedido");*/

      },
      itemCheck(){

        setTimeout(() => {
            this.calcularValorStock();
          }, 100);

      },
      calcularValorStock(){

        let articulosCalculo = this.articulosBusqueda.filter(x => x.check);

        let total = 0;

        articulosCalculo.forEach(articulo => {

          total += articulo.stock * articulo.precio;
          
        });

        this.totalCheck = '£'+total.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');

      },
      limpiarCheck(){

        let articulosCalculo = this.articulosBusqueda.filter(x => x.check);
        let articulosCalculoAll = this.articulos.filter(x => x.check);

        articulosCalculo.forEach(articulo => {
          articulo.check = false;
        });

        articulosCalculoAll.forEach(articulo => {
          articulo.check = false;
        });

        this.calcularValorStock();

      },
      async descargarXlsx(){
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Prevision');

        // Función para obtener letra de columna
        const getColLetter = (colNum) => {
          let letter = '';
          while (colNum > 0) {
            const mod = (colNum - 1) % 26;
            letter = String.fromCharCode(65 + mod) + letter;
            colNum = Math.floor((colNum - 1) / 26);
          }
          return letter;
        };

        //ordenar
        

        // Prefijos de SKU a excluir del listado
        const skuExcluidos = ['card', 'wallet', 'e-gift', 'passport', 'logo', 'deboss', 'courier', 'extra', 'gift', 'leather-customization'];

        // IDs de productos a excluir
        const idsExcluidos = [8160677232923];

        // Función para verificar si un producto debe ser excluido
        const productoExcluido = (product) => {
          // Excluir por ID
          if (idsExcluidos.includes(product.id)) {
            return true;
          }
          // Excluir si el título empieza por "copy"
          if (product.title.toLowerCase().startsWith('copy')) {
            return true;
          }
          // Excluir si algún SKU empieza por los prefijos excluidos
          return product.variants.some(variant => {
            const skuLower = (variant.sku || '').toLowerCase();
            return skuExcluidos.some(prefijo => skuLower.startsWith(prefijo));
          });
        };

        // Primero obtener todos los colores únicos de productos no excluidos
        const allColores = new Set();
        this.allArticulosShopify.forEach(product => {
          if (productoExcluido(product)) {
            return;
          }
          product.variants.forEach(variant => {
            if (variant.option1) {
              allColores.add(variant.option1);
            }
          });
        });
        const colores = Array.from(allColores).sort();

        // Calcular número total de columnas (6 fijas + colores + Total)
        const totalCols = 6 + colores.length + 1;
        const lastColLetter = getColLetter(totalCols);

        // Configurar ancho de columnas
        worksheet.getColumn(1).width = 15; // Imagen
        worksheet.getColumn(2).width = 30; // Title
        worksheet.getColumn(3).width = 20; // Descripcion
        worksheet.getColumn(4).width = 12; // Precio GBP
        worksheet.getColumn(5).width = 12; // Precio EUR
        worksheet.getColumn(6).width = 12; // Precio RON
        colores.forEach((color, index) => {
          worksheet.getColumn(7 + index).width = 10;
        });
        worksheet.getColumn(7 + colores.length).width = 12; // Total

        // Estilo de bordes para el encabezado
        const borderStyle = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        // Función para aplicar bordes a un rango de celdas en una fila
        const applyBordersToRow = (rowNum, numCols) => {
          for (let col = 1; col <= numCols; col++) {
            worksheet.getCell(`${getColLetter(col)}${rowNum}`).border = borderStyle;
          }
        };

        // Fila 1: Customer y Date
        worksheet.addRow([]);
        worksheet.getCell('A1').value = 'Customer:';
        worksheet.getCell('E1').value = 'Date:';
        applyBordersToRow(1, totalCols);
        worksheet.mergeCells('B1:D1');
        worksheet.mergeCells(`F1:${lastColLetter}1`);

        // Fila 2: Contact y Purchase Order
        worksheet.addRow([]);
        worksheet.getCell('A2').value = 'Contact:';
        worksheet.getCell('E2').value = 'Purchase Order:';
        applyBordersToRow(2, totalCols);
        worksheet.mergeCells('B2:D2');
        worksheet.mergeCells(`F2:${lastColLetter}2`);

        // Fila 3: Email y Due Date
        worksheet.addRow([]);
        worksheet.getCell('A3').value = 'Email:';
        worksheet.getCell('E3').value = 'Due Date*:';
        applyBordersToRow(3, totalCols);
        worksheet.mergeCells('B3:D3');
        worksheet.mergeCells(`F3:${lastColLetter}3`);

        // Fila 4: Phone y NOTES
        worksheet.addRow([]);
        worksheet.getCell('A4').value = 'Phone:';
        worksheet.getCell('E4').value = 'NOTES:';
        applyBordersToRow(4, totalCols);
        worksheet.mergeCells('B4:D4');
        worksheet.mergeCells(`F4:${lastColLetter}4`);

        // Fila 5: Fila vacía con bordes
        worksheet.addRow([]);
        applyBordersToRow(5, totalCols);
        worksheet.mergeCells('A5:D5');
        worksheet.mergeCells(`E5:${lastColLetter}5`);

        // Fila 6: Vacía (separación)
        worksheet.addRow([]);

        // Tipos de cambio
        const gbpToEur = 1.18;
        const eurToRon = 5;

        // Definir headers dinámicos
        const headers = ['Imagen', 'Title', 'Descripcion/size', 'Precio GBP', 'Precio EUR', 'Precio RON', ...colores, 'Total'];

        // Añadir headers en fila 7
        worksheet.addRow(headers);

        // Estilo de headers
        worksheet.getRow(7).font = { bold: true };
        worksheet.getRow(7).alignment = { horizontal: 'center', vertical: 'middle' };

        // Agrupar productos por producto + precio
        const productosAgrupados = [];
        this.allArticulosShopify.forEach(product => {
          // Filtrar productos con SKU excluido
          if (productoExcluido(product)) {
            return;
          }

          // Agrupar variantes por precio
          const preciosUnicos = [...new Set(product.variants.map(v => v.price))];

          preciosUnicos.forEach(precio => {
            const variantesConPrecio = product.variants.filter(v => v.price === precio);
            const coloresDisponibles = variantesConPrecio.map(v => v.option1);

            // Buscar imagen de la primera variante
            const primeraVariante = variantesConPrecio[0];
            let imagenUrl = product.image?.src || '';
            const variantImage = product.images.find(img => img.id === primeraVariante.image_id);
            if (variantImage) {
              imagenUrl = variantImage.src;
            }

            productosAgrupados.push({
              imagen: imagenUrl,
              productId: product.id,
              link: `https://www.harberlondon.com/products/${product.handle}`,
              title: product.title,
              descripcion: variantesConPrecio.length > 1 ? variantesConPrecio.map(v => v.title).join(', ') : '',
              precio: parseFloat(precio),
              coloresDisponibles: coloresDisponibles
            });
          });
        });

        // Añadir filas de datos
        let currentRow = 8;
        const imagePromises = [];

        for (const producto of productosAgrupados) {
          // Aplicar 60% de descuento (mostrar 40% del precio original)
          const precioGbp = producto.precio * 0.4;
          const precioEur = precioGbp * gbpToEur;
          const precioRon = precioEur * eurToRon;

          const rowData = [
            '', // Imagen
            producto.title,
            producto.descripcion,
            precioGbp.toFixed(2),
            precioEur.toFixed(2),
            precioRon.toFixed(2)
          ];

          // Añadir columnas de colores
          colores.forEach(color => {
            rowData.push(''); // Celda vacía para cantidad
          });
          rowData.push(''); // Total

          worksheet.addRow(rowData);

          // Añadir hyperlink al título (ahora en columna B)
          worksheet.getCell(`B${currentRow}`).value = {
            text: producto.title,
            hyperlink: producto.link
          };
          worksheet.getCell(`B${currentRow}`).font = { color: { argb: 'FF0000FF' }, underline: true };

          // Pintar gris las celdas de colores no disponibles
          colores.forEach((color, index) => {
            const colNum = 7 + index;
            const colLetter = getColLetter(colNum);
            if (!producto.coloresDisponibles.includes(color)) {
              worksheet.getCell(`${colLetter}${currentRow}`).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
              };
            }
          });

          // Añadir fórmula para Total (SUM colores * Precio EUR)
          const firstColorCol = getColLetter(7);
          const lastColorCol = getColLetter(6 + colores.length);
          const totalCol = getColLetter(7 + colores.length);
          worksheet.getCell(`${totalCol}${currentRow}`).value = {
            formula: `SUM(${firstColorCol}${currentRow}:${lastColorCol}${currentRow})*E${currentRow}`
          };
          worksheet.getCell(`${totalCol}${currentRow}`).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE0E0E0' }
          };

          // Configurar altura de fila
          worksheet.getRow(currentRow).height = 80;
          worksheet.getRow(currentRow).alignment = { horizontal: 'center', vertical: 'middle' };

          // Añadir bordes arriba y abajo a cada celda de la fila
          for (let col = 1; col <= totalCols; col++) {
            worksheet.getCell(`${getColLetter(col)}${currentRow}`).border = {
              top: { style: 'thin' },
              bottom: { style: 'thin' }
            };
          }

          // Guardar promesa de imagen para procesar después
          if (producto.imagen) {
            imagePromises.push({
              url: producto.imagen,
              row: currentRow
            });
          }

          currentRow++;
        }

        // Descargar y añadir todas las imágenes
        for (const imgData of imagePromises) {
          try {
            const response = await fetch(imgData.url);
            const blob = await response.blob();
            const arrayBuffer = await blob.arrayBuffer();

            // Obtener dimensiones originales
            const img = new Image();
            const imageUrl = URL.createObjectURL(blob);
            await new Promise((resolve) => {
              img.onload = resolve;
              img.src = imageUrl;
            });
            URL.revokeObjectURL(imageUrl);

            // Calcular proporciones
            const maxHeight = 75;
            const aspectRatio = img.width / img.height;
            const finalWidth = maxHeight * aspectRatio;
            const finalHeight = maxHeight;

            // Detectar extensión
            let extension = 'jpeg';
            if (blob.type.includes('png')) extension = 'png';
            else if (blob.type.includes('gif')) extension = 'gif';
            else if (blob.type.includes('webp')) extension = 'png';

            const imageId = workbook.addImage({
              buffer: arrayBuffer,
              extension: extension,
            });

            worksheet.addImage(imageId, {
              tl: { col: 0, row: imgData.row - 1 },
              ext: { width: finalWidth, height: finalHeight }
            });
          } catch (error) {
            console.error('Error al cargar imagen:', error);
          }
        }

        // Generar y descargar el archivo
        const buffer = await workbook.xlsx.writeBuffer();
        const blobFile = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blobFile);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'prevision.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);

        this.$bvToast.toast('Excel descargado correctamente', {
          title: 'Descarga',
          variant: 'success',
          solid: true,
        });
      }
    },
     mounted() {
      this.loadItems();
      this.actualizarStickyTop();
      window.addEventListener('scroll', this.actualizarStickyTop, { passive: true });
      window.addEventListener('resize', this.actualizarStickyTop);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.actualizarStickyTop);
      window.removeEventListener('resize', this.actualizarStickyTop);
      if(this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
      if(this.observer) this.observer.disconnect();
    },
    computed: {
      scrollCompleto(){
        // Deja de pedir mas filas cuando ya se muestran todas
        if(this.cargando) return true;
        if(this.agruparPor == 'title')
          return this.countItemView >= new Set(this.articulosBusquedaAll.map(a => a.title || a.sku)).size;
        return this.countItemView >= this.articulosBusquedaAll.length;
      }
    },
    watch: {
      cargando(){
        // El sentinela esta dentro del v-else: se crea al terminar la carga
        if(!this.cargando)
          this.$nextTick(() => {
            this.iniciarObserver();
            this.comprobarSentinela();
          });
      },
      buscar(){
        if(this.buscar == "")
          this.countItemView = this.defaultItemView;
        this.buscarFuncion();
      },
      "itemSelect.pedidoAnual": function (newVal, oldVal){
        if (this.itemSelect.pedidoAnual != undefined)
        {
            axios
                .post("/articulos/sku/pedido",{sku: this.itemSelect.sku, pedidoAnual: this.itemSelect.pedidoAnual, pedidoActual: this.itemSelect.pedidoActual})
                .then(response => {
                    return response.data;
                })
                .then(res => {
                  this.articulos.forEach(element => {
                    if(element.sku == this.itemSelect.sku)
                    {
                      element.pedidoAnual = this.itemSelect.pedidoAnual;
                      element.pedidoActual = this.itemSelect.pedidoActual;
                    }
                    
                  });

                  this.articulosBusqueda.forEach(element => {
                    if(element.sku == this.itemSelect.sku)
                    {
                      element.pedidoAnual = this.itemSelect.pedidoAnual;
                      element.pedidoActual = this.itemSelect.pedidoActual;
                    }
                    
                  });
                });
        }
        
      },
      "itemSelect.pedidoActual": function (newVal, oldVal){

        if (this.itemSelect.pedidoActual != undefined)
        {
            axios
                .post("/articulos/sku/pedido",{sku: this.itemSelect.sku, pedidoAnual: this.itemSelect.pedidoAnual, pedidoActual: this.itemSelect.pedidoActual})
                .then(response => {
                    return response.data;
                })
                .then(res => {   
                  this.articulos.forEach(element => {
                    if(element.sku == this.itemSelect.sku)
                    {
                      element.pedidoAnual = this.itemSelect.pedidoAnual;
                      element.pedidoActual = this.itemSelect.pedidoActual;
                    }
                    
                  });

                  this.articulosBusqueda.forEach(element => {
                    if(element.sku == this.itemSelect.sku)
                    {
                      element.pedidoAnual = this.itemSelect.pedidoAnual;
                      element.pedidoActual = this.itemSelect.pedidoActual;
                    }
                    
                  });

                  this.calcularRRPyCoste();
                });
        }      
        
      },
      meses: {
        handler(newValue, oldValue) {
          if(this.watching)
            this.recalcularDatos();
        },
        deep: true
      },
      anyos: {
        handler(newValue, oldValue) {
          if(this.watching)
            this.recalcularDatos();
        },
        deep: true
      },
      mostrarSelect(){
        this.countItemView = this.defaultItemView;
        this.recalcularDatos();
      },
      localizacionSelect(){
        this.countItemView = this.defaultItemView;
        this.recalcularDatos();
      },
      mesesTodosCheck(){
        this.meses.forEach(mes => {
          mes.active = this.mesesTodosCheck;
        });
      },
      anyosTodosCheck(){
        this.anyos.forEach(anyo => {
          anyo.active = this.anyosTodosCheck;
        });
      },
      tipoSelect(){
        this.buscarFuncion();
      },
      pedidoSelect(){
        this.buscarFuncion();
      }
    }
  }
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/chart-apex.scss';
@import '../@core/scss/vue/libs/vue-select.scss';

// Page layout
.prevision-page {
  .prevision-card-filtros,
  .prevision-card-controles {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
}

// Stats badges
.prevision-stats {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.prevision-stat-badge {
  padding: 0.45rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
}

// Filtros
.prevision-filtros {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.filtro-grupo {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.filtro-header {
  display: flex;
  align-items: center;
}

.filtro-label {
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5e5873;
}

.filtro-separador {
  width: 1px;
  background-color: #ebe9f1;
  align-self: stretch;
  margin: 0 0.25rem;
}

.filtro-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.filtro-chip {
  cursor: pointer;
  padding: 0.45rem 0.85rem;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.15s ease;
  user-select: none;
  border-radius: 5px;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }
}

// Controles (selects + botones)
.prevision-select {
  min-width: 150px;
  max-width: 180px;
}

.prevision-select,
.prevision-agrupar {
  label {
    font-size: 0.78rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #5e5873;
    margin-bottom: 0.2rem;
  }
}

.prevision-agrupar {
  .btn {
    height: 2.714rem;
    display: flex;
    align-items: center;
  }
}

.prevision-input-num {
  width: 60px;
  text-align: center;
  padding: 0.3rem;
}

// Tabla
.table-prevision thead th {
  position: sticky;
  top: var(--sticky-top, 8.9rem); // calculado en actualizarStickyTop() segun la altura real del menu fijo
  z-index: 2;
  background: #f3f2f7;
}

.table-prevision th,
.table-prevision td {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.sku-button {
  cursor: pointer;
  color: #7367f0;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}

.sku-texto {
  color: #5e5873;
  font-weight: 500;
}

.prevision-cargando {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 0;
  color: #5e5873;
}

.fila-grupo td {
  font-weight: 600;
}

.fila-hijo td {
  background: rgba(0, 0, 0, 0.02) !important;
}

.fila-hijo td:first-child {
  padding-left: 2rem;
}

.sku-hijo-controles {
  gap: 0.5rem;
  white-space: nowrap;
}

.grupo-titulo {
  color: #5e5873;
}

.sku-hijo {
  font-weight: 400;
}

.totalCheck {
  position: sticky;
  top: 85px;
  z-index: 99999;
}
</style>